var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 6.66667V5.33333C11.3334 3.49238 9.84097 2 8.00002 2C6.15907 2 4.66669 3.49238 4.66669 5.33333V6.66667M8.00002 9.66667V11M5.86669 14H10.1334C11.2535 14 11.8135 14 12.2413 13.782C12.6177 13.5903 12.9236 13.2843 13.1154 12.908C13.3334 12.4802 13.3334 11.9201 13.3334 10.8V9.86667C13.3334 8.74656 13.3334 8.18651 13.1154 7.75869C12.9236 7.38236 12.6177 7.0764 12.2413 6.88465C11.8135 6.66667 11.2535 6.66667 10.1334 6.66667H5.86669C4.74658 6.66667 4.18653 6.66667 3.75871 6.88465C3.38238 7.0764 3.07642 7.38236 2.88467 7.75869C2.66669 8.18651 2.66669 8.74656 2.66669 9.86667V10.8C2.66669 11.9201 2.66669 12.4802 2.88467 12.908C3.07642 13.2843 3.38238 13.5903 3.75871 13.782C4.18653 14 4.74658 14 5.86669 14Z",
    stroke: "#98A2B3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock01);
export default __webpack_public_path__ + "static/media/lock-01.3748fb7a691bbd7e53b62e49aca45579.svg";
export { ForwardRef as ReactComponent };